import { createApp } from 'vue'
import store from './store'

import segmentPlugin from './plugins/plugin-segment'
import focusTrap from './services/focusTrap'

import 'swiper/swiper-bundle.css'
import './styles/main.scss'
import './styles/css/theme.scss'

import App from './App.vue'
import AppError from './services/errors/app-errors'
import './services/utilities/iframeEventListener/'
import I18n from './services/localization/i18n-setup'
import { setupBroadcastChannel } from './services/broadcastChannel'
import { setCdn } from './services/globals'

const {
  getFontSize,
  getLineHeightForFontSize
} = require('./services/customFontSize')
const app = createApp(App)

// Add global properties
app.config.globalProperties.$getFontSize = getFontSize
app.config.globalProperties.$getLineHeightForFontSize = getLineHeightForFontSize

const cdnUrl = window.parent.document
  .getElementById('netomiChatWindow')
  .getAttribute('sdk_cdn')
app.config.globalProperties.$cdn = cdnUrl
// Also set in globals for backward compatibility
setCdn(cdnUrl)

// Add store and i18n
app.use(store)
app.use(I18n.i18n)
app.use(segmentPlugin)

// Setup broadcast channel
setupBroadcastChannel(app)

// Global error handler
app.config.errorHandler = (error, instance, info) => {
  console.error('Vue Error:', error)
  console.error('Error Info:', info)
  console.error('Component Instance:', instance)

  // Log the error but don't throw to avoid breaking the app
  console.error(
    new AppError({
      name: 'Vue',
      message: error.message,
      stackTrace: error.stack
    })
  )
}

// Register global directives
app.directive('focus-trap', focusTrap)

app.directive('click-outside', {
  mounted(el, binding) {
    el.clickOutsideEvent = function (event) {
      if (!(el == event.target || el.contains(event.target))) {
        binding.value(event)
      }
    }
    window.parent.document.addEventListener('click', el.clickOutsideEvent)
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unmounted(el) {
    window.parent.document.removeEventListener('click', el.clickOutsideEvent)
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})

export { app, store }
